import {
  onTerminalnumSendCommand,
  sendCommand,
  sendCommandAfter2019,
  setupRegistration,
  restart,
  setupMileage,
  setupReportInterval,
  batchSetupReportInterval,
  batchSendCmd,
  jt1078ReqRealtimeAVTrans,
  jt1078CtrlRealtimeAVTrans,
  dataDownlinkTransmission,
  queryTerminalAttribute,
  setMaxSpeed,
  batchSetMaxSpeed,
  setOverSpeedDuration,
  batchSetOverSpeedDuration,
  setContinueDriveLimit,
  batchSetContinueDriveLimit,
  setContinueDriveLimitPerDay,
  batchSetContinueDriveLimitPerDay,
  setMinRestingTime,
  batchSetMinRestingTime,
  setMaxStopTime,
  batchSetMaxStopTime,
  setOverSpeedAlarmDifference,
  batchSetOverSpeedAlarmDifference,
  setFatigueDrivingAlarmDifference,
  batchSetFatigueDrivingAlarmDifference,
  setAcquisitionCommand,
} from '@/api/netcommandserv'

export default {
  state: {
    state_NetCommand_OnTerminalnumSendCommandResult: null,
    state_NetCommand_SendCommandResult: null,
    state_NetCommand_SendCommandAfter2019Result: null,
    state_NetCommand_SetupRegistrationResult: null,
    state_NetCommand_RestartResult: null,
    state_NetCommand_SetupMileageResult: null,
    state_NetCommand_SetupReportIntervalResult: null,
    state_NetCommand_BatchSetupReportIntervalResult: null,
    state_NetCommand_BatchSendCmdResult: null,
    state_NetCommand_Jt1078ReqRealtimeAVTransResult: null,
    state_NetCommand_Jt1078CtrlRealtimeAVTransResult: null,
    state_NetCommand_DataDownlinkTransmissionResult: null,
    state_NetCommand_QueryTerminalAttributeResult: null,
    state_NetCommand_SetMaxSpeedResult: null,
    state_NetCommand_BatchSetMaxSpeedResult: null,
    state_NetCommand_SetOverSpeedDurationResult: null,
    state_NetCommand_BatchSetOverSpeedDurationResult: null,
    state_NetCommand_SetContinueDriveLimitResult: null,
    state_NetCommand_BatchSetContinueDriveLimitResult: null,
    state_NetCommand_SetContinueDriveLimitPerDayResult: null,
    state_NetCommand_BatchSetContinueDriveLimitPerDayResult: null,
    state_NetCommand_SetMinRestingTimeResult: null,
    state_NetCommand_BatchSetMinRestingTimeResult: null,
    state_NetCommand_SetMaxStopTimeResult: null,
    state_NetCommand_BatchSetMaxStopTimeResult: null,
    state_NetCommand_SetOverSpeedAlarmDifferenceResult: null,
    state_NetCommand_BatchSetOverSpeedAlarmDifferenceResult: null,
    state_NetCommand_SetFatigueDrivingAlarmDifferenceResult: null,
    state_NetCommand_BatchSetFatigueDrivingAlarmDifferenceResult: null,
    state_NetCommand_SetAcquisitionCommandResult: null,
  },
  mutations: {
    SET_NETCOMMAND_ONTERMINALNUMSENDCOMMAND_RESULT: (state, rst) => {
      state.state_NetCommand_OnTerminalnumSendCommandResult = rst;
    },
    SET_NETCOMMAND_SENDCOMMAND_RESULT: (state, rst) => {
      state.state_NetCommand_SendCommandResult = rst;
    },
    SET_NETCOMMAND_SENDCOMMANDAFTER2019_RESULT: (state, rst) => {
      state.state_NetCommand_SendCommandAfter2019Result = rst;
    },
    SET_NETCOMMAND_SETUPREGISTRATION_RESULT: (state, rst) => {
      state.state_NetCommand_SetupRegistrationResult = rst;
    },
    SET_NETCOMMAND_RESTART_RESULT: (state, rst) => {
      state.state_NetCommand_RestartResult = rst;
    },
    SET_NETCOMMAND_SETUPMILEAGE_RESULT: (state, rst) => {
      state.state_NetCommand_SetupMileageResult = rst;
    },
    SET_NETCOMMAND_SETUPREPORTINTERVAL_RESULT: (state, rst) => {
      state.state_NetCommand_SetupReportIntervalResult = rst;
    },
    SET_NETCOMMAND_BATCHSETUPREPORTINTERVAL_RESULT: (state, rst) => {
      state.state_NetCommand_BatchSetupReportIntervalResult = rst;
    },
    SET_NETCOMMAND_BATCHSENDCMD_RESULT: (state, rst) => {
      state.state_NetCommand_BatchSendCmdResult = rst;
    },
    SET_NETCOMMAND_JT1078REQREALTIMEAVTRANS_RESULT: (state, rst) => {
      state.state_NetCommand_Jt1078ReqRealtimeAVTransResult = rst;
    },
    SET_NETCOMMAND_JT1078CTRLREALTIMEAVTRANS_RESULT: (state, rst) => {
      state.state_NetCommand_Jt1078CtrlRealtimeAVTransResult = rst;
    },
    SET_NETCOMMAND_DATADOWNLINKTRANSMISSION_RESULT: (state, rst) => {
      state.state_NetCommand_DataDownlinkTransmissionResult = rst;
    },
    SET_NETCOMMAND_QUERYTERMINALATTRIBUTE_RESULT: (state, rst) => {
      state.state_NetCommand_QueryTerminalAttributeResult = rst;
    },
    SET_NETCOMMAND_SETMAXSPEED_RESULT: (state, rst) => {
      state.state_NetCommand_SetMaxSpeedResult = rst;
    },
    SET_NETCOMMAND_BATCHSETMAXSPEED_RESULT: (state, rst) => {
      state.state_NetCommand_BatchSetMaxSpeedResult = rst;
    },
    SET_NETCOMMAND_SETOVERSPEEDDURATION_RESULT: (state, rst) => {
      state.state_NetCommand_SetOverSpeedDurationResult = rst;
    },
    SET_NETCOMMAND_BATCHSETOVERSPEEDDURATION_RESULT: (state, rst) => {
      state.state_NetCommand_BatchSetOverSpeedDurationResult = rst;
    },
    SET_NETCOMMAND_SETCONTINUEDRIVELIMIT_RESULT: (state, rst) => {
      state.state_NetCommand_SetContinueDriveLimitResult = rst;
    },
    SET_NETCOMMAND_BATCHSETCONTINUEDRIVELIMIT_RESULT: (state, rst) => {
      state.state_NetCommand_BatchSetContinueDriveLimitResult = rst;
    },
    SET_NETCOMMAND_SETCONTINUEDRIVELIMITPERDAY_RESULT: (state, rst) => {
      state.state_NetCommand_SetContinueDriveLimitPerDayResult = rst;
    },
    SET_NETCOMMAND_BATCHSETCONTINUEDRIVELIMITPERDAY_RESULT: (state, rst) => {
      state.state_NetCommand_BatchSetContinueDriveLimitPerDayResult = rst;
    },
    SET_NETCOMMAND_SETMINRESTINGTIME_RESULT: (state, rst) => {
      state.state_NetCommand_SetMinRestingTimeResult = rst;
    },
    SET_NETCOMMAND_BATCHSETMINRESTINGTIME_RESULT: (state, rst) => {
      state.state_NetCommand_BatchSetMinRestingTimeResult = rst;
    },
    SET_NETCOMMAND_SETMAXSTOPTIME_RESULT: (state, rst) => {
      state.state_NetCommand_SetMaxStopTimeResult = rst;
    },
    SET_NETCOMMAND_BATCHSETMAXSTOPTIME_RESULT: (state, rst) => {
      state.state_NetCommand_BatchSetMaxStopTimeResult = rst;
    },
    SET_NETCOMMAND_SETOVERSPEEDALARMDIFFERENCE_RESULT: (state, rst) => {
      state.state_NetCommand_SetOverSpeedAlarmDifferenceResult = rst;
    },
    SET_NETCOMMAND_BATCHSETOVERSPEEDALARMDIFFERENCE_RESULT: (state, rst) => {
      state.state_NetCommand_BatchSetOverSpeedAlarmDifferenceResult = rst;
    },
    SET_NETCOMMAND_SETFATIGUEDRIVINGALARMDIFFERENCE_RESULT: (state, rst) => {
      state.state_NetCommand_SetFatigueDrivingAlarmDifferenceResult = rst;
    },
    SET_NETCOMMAND_BATCHSETFATIGUEDRIVINGALARMDIFFERENCE_RESULT: (state, rst) => {
      state.state_NetCommand_BatchSetFatigueDrivingAlarmDifferenceResult = rst;
    },
    SET_NETCOMMAND_SETACQUISITIONCOMMAND_RESULT: (state, rst) => {
      state.state_NetCommand_SetAcquisitionCommandResult = rst;
    },
  },
  actions: {
    NetCommandServ_OnTerminalnumSendCommand({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        onTerminalnumSendCommand(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_ONTERMINALNUMSENDCOMMAND_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_ONTERMINALNUMSENDCOMMAND_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_SendCommand({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        sendCommand(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_SENDCOMMAND_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_SENDCOMMAND_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_SendCommandAfter2019({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        sendCommandAfter2019(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_SENDCOMMANDAFTER2019_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_SENDCOMMANDAFTER2019_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_SetupRegistration({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        setupRegistration(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_SETUPREGISTRATION_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_SETUPREGISTRATION_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_Restart({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        restart(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_RESTART_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_RESTART_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_SetupMileage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        setupMileage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_SETUPMILEAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_SETUPMILEAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_SetupReportInterval({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        setupReportInterval(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_SETUPREPORTINTERVAL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_SETUPREPORTINTERVAL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_BatchSetupReportInterval({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        batchSetupReportInterval(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_BATCHSETUPREPORTINTERVAL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_BATCHSETUPREPORTINTERVAL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_BatchSendCmd({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        batchSendCmd(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_BATCHSENDCMD_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_BATCHSENDCMD_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_Jt1078ReqRealtimeAVTrans({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        jt1078ReqRealtimeAVTrans(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_JT1078REQREALTIMEAVTRANS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_JT1078REQREALTIMEAVTRANS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_Jt1078CtrlRealtimeAVTrans({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        jt1078CtrlRealtimeAVTrans(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_JT1078CTRLREALTIMEAVTRANS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_JT1078CTRLREALTIMEAVTRANS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_DataDownlinkTransmission({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        dataDownlinkTransmission(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_DATADOWNLINKTRANSMISSION_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_DATADOWNLINKTRANSMISSION_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_QueryTerminalAttribute({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        queryTerminalAttribute(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_QUERYTERMINALATTRIBUTE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_QUERYTERMINALATTRIBUTE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_SetMaxSpeed({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        setMaxSpeed(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_SETMAXSPEED_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_SETMAXSPEED_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_BatchSetMaxSpeed({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        batchSetMaxSpeed(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_BATCHSETMAXSPEED_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_BATCHSETMAXSPEED_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_SetOverSpeedDuration({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        setOverSpeedDuration(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_SETOVERSPEEDDURATION_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_SETOVERSPEEDDURATION_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_BatchSetOverSpeedDuration({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        batchSetOverSpeedDuration(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_BATCHSETOVERSPEEDDURATION_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_BATCHSETOVERSPEEDDURATION_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_SetContinueDriveLimit({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        setContinueDriveLimit(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_SETCONTINUEDRIVELIMIT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_SETCONTINUEDRIVELIMIT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_BatchSetContinueDriveLimit({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        batchSetContinueDriveLimit(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_BATCHSETCONTINUEDRIVELIMIT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_BATCHSETCONTINUEDRIVELIMIT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_SetContinueDriveLimitPerDay({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        setContinueDriveLimitPerDay(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_SETCONTINUEDRIVELIMITPERDAY_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_SETCONTINUEDRIVELIMITPERDAY_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_BatchSetContinueDriveLimitPerDay({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        batchSetContinueDriveLimitPerDay(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_BATCHSETCONTINUEDRIVELIMITPERDAY_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_BATCHSETCONTINUEDRIVELIMITPERDAY_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_SetMinRestingTime({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        setMinRestingTime(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_SETMINRESTINGTIME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_SETMINRESTINGTIME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_BatchSetMinRestingTime({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        batchSetMinRestingTime(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_BATCHSETMINRESTINGTIME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_BATCHSETMINRESTINGTIME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_SetMaxStopTime({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        setMaxStopTime(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_SETMAXSTOPTIME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_SETMAXSTOPTIME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_BatchSetMaxStopTime({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        batchSetMaxStopTime(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_BATCHSETMAXSTOPTIME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_BATCHSETMAXSTOPTIME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_SetOverSpeedAlarmDifference({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        setOverSpeedAlarmDifference(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_SETOVERSPEEDALARMDIFFERENCE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_SETOVERSPEEDALARMDIFFERENCE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_BatchSetOverSpeedAlarmDifference({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        batchSetOverSpeedAlarmDifference(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_BATCHSETOVERSPEEDALARMDIFFERENCE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_BATCHSETOVERSPEEDALARMDIFFERENCE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_SetFatigueDrivingAlarmDifference({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        setFatigueDrivingAlarmDifference(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_SETFATIGUEDRIVINGALARMDIFFERENCE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_SETFATIGUEDRIVINGALARMDIFFERENCE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_BatchSetFatigueDrivingAlarmDifference({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        batchSetFatigueDrivingAlarmDifference(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_BATCHSETFATIGUEDRIVINGALARMDIFFERENCE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_BATCHSETFATIGUEDRIVINGALARMDIFFERENCE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NetCommandServ_SetAcquisitionCommand({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        setAcquisitionCommand(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NETCOMMAND_SETACQUISITIONCOMMAND_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NETCOMMAND_SETACQUISITIONCOMMAND_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_NetCommand_OnTerminalnumSendCommandResult: state => {
      return state.state_NetCommand_OnTerminalnumSendCommandResult;
    },
    get_NetCommand_SendCommandResult: state => {
      return state.state_NetCommand_SendCommandResult;
    },
    get_NetCommand_SendCommandAfter2019Result: state => {
      return state.state_NetCommand_SendCommandAfter2019Result;
    },
    get_NetCommand_SetupRegistrationResult: state => {
      return state.state_NetCommand_SetupRegistrationResult;
    },
    get_NetCommand_RestartResult: state => {
      return state.state_NetCommand_RestartResult;
    },
    get_NetCommand_SetupMileageResult: state => {
      return state.state_NetCommand_SetupMileageResult;
    },
    get_NetCommand_SetupReportIntervalResult: state => {
      return state.state_NetCommand_SetupReportIntervalResult;
    },
    get_NetCommand_BatchSetupReportIntervalResult: state => {
      return state.state_NetCommand_BatchSetupReportIntervalResult;
    },
    get_NetCommand_BatchSendCmdResult: state => {
      return state.state_NetCommand_BatchSendCmdResult;
    },
    get_NetCommand_Jt1078ReqRealtimeAVTransResult: state => {
      return state.state_NetCommand_Jt1078ReqRealtimeAVTransResult;
    },
    get_NetCommand_Jt1078CtrlRealtimeAVTransResult: state => {
      return state.state_NetCommand_Jt1078CtrlRealtimeAVTransResult;
    },
    get_NetCommand_DataDownlinkTransmissionResult: state => {
      return state.state_NetCommand_DataDownlinkTransmissionResult;
    },
    get_NetCommand_QueryTerminalAttributeResult: state => {
      return state.state_NetCommand_QueryTerminalAttributeResult;
    },
    get_NetCommand_SetMaxSpeedResult: state => {
      return state.state_NetCommand_SetMaxSpeedResult;
    },
    get_NetCommand_BatchSetMaxSpeedResult: state => {
      return state.state_NetCommand_BatchSetMaxSpeedResult;
    },
    get_NetCommand_SetOverSpeedDurationResult: state => {
      return state.state_NetCommand_SetOverSpeedDurationResult;
    },
    get_NetCommand_BatchSetOverSpeedDurationResult: state => {
      return state.state_NetCommand_BatchSetOverSpeedDurationResult;
    },
    get_NetCommand_SetContinueDriveLimitResult: state => {
      return state.state_NetCommand_SetContinueDriveLimitResult;
    },
    get_NetCommand_BatchSetContinueDriveLimitResult: state => {
      return state.state_NetCommand_BatchSetContinueDriveLimitResult;
    },
    get_NetCommand_SetContinueDriveLimitPerDayResult: state => {
      return state.state_NetCommand_SetContinueDriveLimitPerDayResult;
    },
    get_NetCommand_BatchSetContinueDriveLimitPerDayResult: state => {
      return state.state_NetCommand_BatchSetContinueDriveLimitPerDayResult;
    },
    get_NetCommand_SetMinRestingTimeResult: state => {
      return state.state_NetCommand_SetMinRestingTimeResult;
    },
    get_NetCommand_BatchSetMinRestingTimeResult: state => {
      return state.state_NetCommand_BatchSetMinRestingTimeResult;
    },
    get_NetCommand_SetMaxStopTimeResult: state => {
      return state.state_NetCommand_SetMaxStopTimeResult;
    },
    get_NetCommand_BatchSetMaxStopTimeResult: state => {
      return state.state_NetCommand_BatchSetMaxStopTimeResult;
    },
    get_NetCommand_SetOverSpeedAlarmDifferenceResult: state => {
      return state.state_NetCommand_SetOverSpeedAlarmDifferenceResult;
    },
    get_NetCommand_BatchSetOverSpeedAlarmDifferenceResult: state => {
      return state.state_NetCommand_BatchSetOverSpeedAlarmDifferenceResult;
    },
    get_NetCommand_SetFatigueDrivingAlarmDifferenceResult: state => {
      return state.state_NetCommand_SetFatigueDrivingAlarmDifferenceResult;
    },
    get_NetCommand_BatchSetFatigueDrivingAlarmDifferenceResult: state => {
      return state.state_NetCommand_BatchSetFatigueDrivingAlarmDifferenceResult;
    },
    get_NetCommand_SetAcquisitionCommandResult: state => {
      return state.state_NetCommand_SetAcquisitionCommandResult;
    },
  }
}